import React from 'react'
import Dropzone from 'react-dropzone'
import ReactCrop from 'react-image-crop'

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import styled, { css } from 'styled-components'
import { axiosClient } from 'store'
import LazyImage from 'components/LazyImage'

import Label from './Label'

const DropZoneArea = styled(Dropzone)`
  width: 256px;
  min-height: 64px;
  border-radius: 4px;
  background-color: white;
  overflow: hidden;
  cursor: pointer;
  ${props =>
    props.empty
      ? css`
          border: 1px dashed #888;
          background-color: #333;
        `
      : null};
`

class ImageDropZone extends React.Component {
  state = {
    showModal: false,
    file: null,

    name: null,
    src: null,
    crop: {}
  }

  toggleModal = () => {
    return this.setState(prevState => ({
      showModal: !prevState.showModal
    }))
  }

  onImageLoaded = async image => {
    this.setState(
      {
        image,
        imageWidth: image.naturalWidth,
        imageHeight: image.naturalHeight,
        crop: null,
        pixelCrop: null
      },
      () =>
        this.createCanvas({
          x: 0,
          y: 0,
          width: image.naturalWidth,
          height: image.naturalHeight
        })
    )

    //return false
  }

  onDrop = async (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const reader = new FileReader()
      let name = acceptedFiles[0].name

      reader.addEventListener(
        'load',
        () =>
          this.setState(prevState => ({
            name,
            showModal: !prevState.showModal,
            src: reader.result,
            loading: false,
            progress: 0
          })),
        false
      )

      reader.readAsDataURL(acceptedFiles[0])
    } else {
      console.error('Files rejected: ', rejectedFiles)
    }
  }

  onCropComplete = (crop, pixelCrop) => {
    //console.log('onCropComplete', crop, pixelCrop)
    this.setState(
      {
        crop,
        pixelCrop
      },
      () => {
        this.createCanvas(pixelCrop)
      }
    )
  }

  onCropChange = (crop, pixelCrop) => {
    this.setState({ crop, pixelCrop })
  }

  createCanvas = pixelCrop => {
    if (!this.canvas) {
      this.canvas = document.createElement('canvas')
    }

    console.log('Sizing canvas to: ', pixelCrop)

    this.canvas.width = pixelCrop.width
    this.canvas.height = pixelCrop.height
    const ctx = this.canvas.getContext('2d')

    ctx.drawImage(
      this.state.image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      this.canvas.width,
      this.canvas.height
    )
  }

  getCroppedImg = () => {
    const { name } = this.state
    const canvas = this.canvas

    return new Promise((resolve, reject) => {
      try {
        canvas.toBlob(file => {
          if (!file) {
            return
          }

          file.name = name

          this.setState({ file })

          resolve(file)
        }, 'image/png')
      } catch (error) {
        console.error(error)
        reject('blob was rejected.')
      }
    })
  }

  upload = async file =>
    await axiosClient.post('/api/upload', file, {
      timeout: 30000
    })

  uploadFile = async () => {
    let formData = new FormData()
    let blob = await this.getCroppedImg()
    formData.append('blob', blob, this.state.name)

    try {
      let uploadResult = await this.upload(formData)

      this.setState({
        showModal: false,
        loading: false
      })

      return this.props.onDrop(uploadResult.data[0])
    } catch (error) {
      console.error(error)
    }
  }

  resetCrop = () => {
    this.setState(
      {
        crop: {
          unit: '%',
          with: 100,
          height: 100
        }
      },
      () => {
        this.createCanvas({
          x: 0,
          y: 0,
          width: this.state.image.naturalWidth,
          height: this.state.image.naturalHeight
        })
      }
    )
  }

  render() {
    const { value } = this.props
    let isEmpty = 'yes'
    if (value && value.url) {
      isEmpty = undefined
    }

    return (
      <div>
        <DropZoneArea
          accept="image/jpg, image/png, image/jpeg"
          empty={isEmpty}
          onDrop={this.onDrop}
          style={{ ...this.props.style }}
        >
          {value && value.url && (
            <LazyImage
              style={{
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              src={value.url}
            />
          )}
        </DropZoneArea>
        <Modal
          isOpen={this.state.showModal}
          toggle={this.toggleModal}
          //          size={'sm'}
        >
          <ModalHeader toggle={this.toggleModal}>Crop Image</ModalHeader>
          <ModalBody style={{ backgroundColor: '#f0f0f0' }}>
            {this.state.src && (
              <ReactCrop
                name={this.state.name}
                src={this.state.src}
                crop={this.state.crop}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleModal}>
              Cancel
            </Button>
            <Button color="secondary" onClick={this.resetCrop}>
              Reset Crop
            </Button>
            <Button color="primary" onClick={this.uploadFile}>
              Finish
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ({ label, data, field, onChange, ...rest }) => (
  <div style={{ marginBottom: 8 }} {...rest}>
    <Label text={label} />
    <ImageDropZone
      value={data[field]}
      onDrop={image => {
        let newData = { ...data }
        newData[field] = image
        onChange(newData)
      }}
    />
  </div>
)
